// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8792) return "main.03eab520.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"1810":"2ac99cbe","2910":"8d7d9fe1","3799":"36d0e46b","8577":"46657d27"}[chunkId] + ".chunk.css";
};